import * as utils from 'Utils';


export function getBackInStockPayloads(successCallback, errorCallback, bisId, qs={}) {
  utils.getRq({
    "url": utils.buildUrl(`back-in-stock-payloads/${bisId}`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function postAddBackInStockSubscribers(successCallback, errorCallback, data) {
  utils.postRq({
    "url": utils.buildUrl(`add-back-in-stock-subscribers`),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function postUpdateBackInStockVisitor(successCallback, errorCallback, cookieId, data) {
  utils.postRq({
    "url": utils.buildUrl(`back-in-stock-visitors/${cookieId}/update`),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}
